<app-legal-document-preview [legalDocument]="legalDocument$ | async"/>
